import axiosClient from './axiosClient';

export const dashboardApi = {
  getDashboard(params = {}) {
    return axiosClient.get(
      '/dashboard',
      {
        params,
      },
    );
  },
};

export default dashboardApi;